const FINN_DYNAMIC_IMAGE = /^(https:\/\/images\.finncdn\.no\/dynamic\/)[^/]+\//;

/** Only some sizes exist on the CDN (e.g. 80w, 240w, 480w); unknown ones return 404. */
export type ImageSize = '142w' | '159w' | '240w' | '320w';

export function resizeImage(url: string, size: ImageSize): string {
    return url.replace(FINN_DYNAMIC_IMAGE, `$1${size}/`);
}

/** Same sizes as the agent photo in company-profile on the ad page. */
const AGENT_PHOTO_DENSITIES: [ImageSize, string][] = [
    ['142w', '1x'],
    ['159w', '2x'],
    ['240w', '3x'],
    ['320w', '3.5x'],
];

export function agentPhotoSrcSet(url: string): string {
    return AGENT_PHOTO_DENSITIES.map(([size, density]) => `${resizeImage(url, size)} ${density}`).join(', ');
}
